import { Injectable } from '@angular/core';
import { applyHighchartsTheme } from '../../shared/highcharts/highcharts-instance';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  setTheme(theme: string) {
    const body = document.body;

    body.classList.remove('theme-light', 'theme-dark', 'theme-yellow','theme-pink','theme-green','theme-blue');
    body.classList.add(theme);

    localStorage.setItem('app-theme', theme);
    applyHighchartsTheme(theme);
  }

  loadTheme() {
    const saved = localStorage.getItem('app-theme') || 'theme-light';
    this.setTheme(saved);
  }
}